import ConditionalRuleSet from "~/models/conditionalRules/conditionalRuleSet";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import {ConditionalFieldDefinition} from "~/models/conditionalRules/conditionalFieldDefinition";
import AdvancedFilterConditionalRule from "./advancedFilterConditionalRule";

export default class AdvancedFilterConditionalRuleSet extends ConditionalRuleSet {
  static repo: IRepo<AdvancedFilterConditionalRuleSet> = new Repo('conditionalRuleSets', AdvancedFilterConditionalRuleSet);

  constructor(fieldName: string, definition: ConditionalFieldDefinition) {
    super(fieldName, definition);
  }

  createNew(fieldName: string, conditionalFieldDefinition: ConditionalFieldDefinition): ConditionalRuleSet {
    return new AdvancedFilterConditionalRuleSet(fieldName, conditionalFieldDefinition);
  }

  createNewRule(): AdvancedFilterConditionalRule {
    return new AdvancedFilterConditionalRule();
  }

  get conditionalRulesArray(): AdvancedFilterConditionalRule[] {
    // AdvancedFilterConditionalRuleSets cannot contain other ConditionalRuleSets
    return this.conditionalRules as AdvancedFilterConditionalRule[];
  }
}